import 'jquery';

let app = {};

app.initCasesSlider = function () {
	const asyncSwiper = elementorFrontend.utils.swiper;

	let $el = $('.cases-slider');
	if (!$el.length) {
		console.log('CasesSlider not found.');
		return false;
	}

	$el.each(function (i, el) {
		let args = {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				nextEl: $(this).parent().children('.cases-slider-button--next').get(0),
				prevEl: $(this).parent().children('.cases-slider-button--prev').get(0),
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 20,
				}
			}
		};

		new asyncSwiper(el, args).then((newSwiperInstance) => {
		});
	});
};

app.initPostFeaturedImageBackground = function () {
	if (WpPostData.featured_image) {
		$('.el-hero-section').css('--featured-image', `url('${WpPostData.featured_image}')`);
	}
};

$(document).ready(() => {
	app.initCasesSlider();
	app.initPostFeaturedImageBackground();
});
